import { useMutation } from '@apollo/client';
import { Mutations } from '../../rest/Mutations';
import { feedbackMutation } from '../../rest/mutations/feedback.post';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { RespuestaFeedback } from '../../model/preguntas/RespuestaFeedback';
import { FeedbackData } from '../../model/preguntas/FeedbackData';

type ValidResponseHandler = (data: RespuestaFeedback, votoData: FeedbackData) => void;

export function useFeedbackSender(handleValidResponse: ValidResponseHandler, logTag?: string) {
  const [sendFeedback] = useMutation<Mutations>(feedbackMutation);
  const { executeRecaptcha } = useGoogleReCaptcha();

  /**Token de Google Recaptcha */
  async function getRecaptchaToken() {
    if (!executeRecaptcha) {
      return undefined;
    }
    return await executeRecaptcha();
  }

  function handleResponse(feedbackData: FeedbackData, respuesta?: RespuestaFeedback) {
    if (!respuesta?.idBtn) {
      handleError();
      return;
    }
    handleValidResponse(respuesta, feedbackData);
  }

  function handleError(x?: any) {
    console.log(`[${logTag}] handleError ${x ? x : ''}`);
  }

  async function send(feedbackData: FeedbackData) {
    const token: string | undefined = await getRecaptchaToken();

    if (!token) {
      handleError('Error de GoogleRecaptcha');
      return;
    }
    const requestData: FeedbackData = { ...feedbackData, googleToken: token };

    sendFeedback({ variables: { input: requestData } })
      .then((x) => handleResponse(feedbackData, x?.data?.respuestaFeedback))
      .catch((x) => handleError(x));
  }
  return [send] as const;
}
